/**
 * Floor plan visual themes – light (print-like) and dark (sketching).
 */
export type CanvasTheme = 'light' | 'dark';

export interface FloorPlanThemeTokens {
  canvas: { background: string };
  grid: { stroke: string };
  wall: { stroke: string; strokeWidth: number; selectedStroke: string };
  preview: { stroke: string; fill: string; dot: string };
  guide: { stroke: string };
  hintBar: { background: string; border: string; text: string };
  dimensionsOverlay: { background: string; border: string; text: string };
}

export const LIGHT_THEME: FloorPlanThemeTokens = {
  canvas: { background: '#fafafa' },
  grid: { stroke: '#e0e0e0' },
  wall: { stroke: '#333333', strokeWidth: 2.5, selectedStroke: '#2563eb' },
  preview: { stroke: '#2563eb', fill: 'rgba(37, 99, 235, 0.12)', dot: '#2563eb' },
  guide: { stroke: '#0284c7' },
  hintBar: { background: 'rgba(255,255,255,0.95)', border: '#e0e0e0', text: '#555555' },
  dimensionsOverlay: { background: 'rgba(255,255,255,0.95)', border: '#2563eb', text: '#333333' },
};

export const DARK_THEME: FloorPlanThemeTokens = {
  canvas: { background: '#111118' },
  grid: { stroke: '#2a2a3a' },
  wall: { stroke: '#e8e8f0', strokeWidth: 2.5, selectedStroke: '#3b82f6' },
  preview: { stroke: '#FF4C4C', fill: 'rgba(255, 76, 76, 0.15)', dot: '#FF4C4C' },
  guide: { stroke: '#38bdf8' },
  hintBar: { background: '#1c1c28', border: '#2e2e40', text: '#8888aa' },
  dimensionsOverlay: { background: '#1c1c28', border: '#FF4C4C', text: '#e8e8f0' },
};

export const THEMES: Record<CanvasTheme, FloorPlanThemeTokens> = {
  light: LIGHT_THEME,
  dark: DARK_THEME,
};

/** @deprecated Use THEMES[canvasTheme] instead */
export const FLOORPLAN_THEME = LIGHT_THEME;
